import { Component, OnInit, OnDestroy } from '@angular/core';
import { ExercicioService } from '../service/exercicio.service';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Login } from '../../entidade/login/login';
import { Exercicio } from '../../entidade/comum/exercicio.model';
import { FuncaoService } from '../../util/funcao.service';
import { GlobalService } from '../../util/global.service';
import { PpaService } from '../../login/servico/ppa.service';
import { ParametroRequisicaoService } from '../../requisicao/parametros-requisicao/service/parametro-requisicao.service';

@Component({
  selector: 'lib-trocar-exercicio',
  templateUrl: './trocar-exercicio.component.html'
})
export class TrocarExercicioComponent implements OnInit, OnDestroy {

  public login: Login = new Login();
  public exercicio: Exercicio = new Exercicio();
  public listaExercicios: Array<any>;
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected router: Router,
    protected funcaoService: FuncaoService,
    private exercicioService: ExercicioService,
    private ppaService: PpaService,
    private parametroRequisicaoService: ParametroRequisicaoService,
  ) { }

  ngOnInit() {
    this.login = GlobalService.obterSessaoLogin();
    if (this.login) {
      this.exercicio = this.login.exercicio;
      this.exercicioService.obterTodosOrdenadoPorAno(this.login.cidade.id).pipe(takeUntil(this.unsubscribe))
        .subscribe(dados => {
          this.listaExercicios = dados.content;
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  enviar() {
    this.login.exercicio = this.exercicio;
    this.ppaService.obterPorAno(this.login.exercicio.ano, this.login.cidade.id).subscribe(async (res) => {
      this.login['ppa'] = res;
      this.parametroRequisicaoService.login = this.login;
      this.login.parametro = this.login.parametro ? this.login.parametro : {};
      this.login.parametro['requisicao'] = await this.parametroRequisicaoService.obterParametro(this.login.orgao.id, this.login.exercicio.id).toPromise();
      GlobalService.salvarSessaoLogin(this.login);
      reloadSession();
    });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

}

export const reloadSession = () => {
  // Limpa variáveis do portal contábil
  sessionStorage.setItem('listaco4', '');
  sessionStorage.setItem('listaco5', '');
  sessionStorage.setItem('lista1', '');
  sessionStorage.setItem('listaco3', '');
  sessionStorage.setItem('listaco2', '');
  sessionStorage.setItem('totalArrecadadoco', '');
  sessionStorage.setItem('totalEmpenhadoco', '');
  sessionStorage.setItem('totalLiquidadoco', '');
  sessionStorage.setItem('totalPagoco', '');
  
  // Limpa variáveis do controle interno
  // Remove todas as chaves que contêm os padrões dos gráficos de controle interno
  const keysToRemove = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && (
      key.startsWith('lista1_') ||
      key.startsWith('listaci2_') ||
      key.startsWith('listaci3_') ||
      key.startsWith('listaci4_') ||
      key.startsWith('listaci5_') ||
      key.startsWith('saldoBancarioci_') ||
      key.startsWith('totalArrecadadoci_') ||
      key.startsWith('totalEmpenhadoci_') ||
      key.startsWith('totalLiquidadoci_') ||
      key.startsWith('totalPagoci_') ||
      key.startsWith('totalPrevistoci_') ||
      key.startsWith('duodecimo_anual_ci_') ||
      key.startsWith('devolucao_anual_ci_') ||
      key.startsWith('duodecimo_mensal_ci_')
    )) {
      keysToRemove.push(key);
    }
  }
  
  // Remove as chaves identificadas
  keysToRemove.forEach(key => sessionStorage.removeItem(key));
  
  location.reload();
}
